import React, {useEffect, useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './HeaderAndFooterLayout.css'
import {Link as RouterLink, useLocation, Link} from "react-router-dom";
import {strings} from "../../../strings";
import Collapse from "@mui/material/Collapse";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ListItemButton from '@mui/material/ListItemButton';
import {CacheProvider} from '@emotion/react';
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import logo from "../../../Image/logoHeader.png";
import {usePromiseTracker} from "react-promise-tracker";
import Loader from "react-promise-loader";
import {deleteProduct} from "../../../stores/product/thunks";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import {logOut} from "../../../stores/base/basethunks";
import {useDispatch} from "react-redux";
import Notifier from "../LoginForm/Notifier";
import {LoadingComponents} from "../../module";

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
});

const drawerWidth = 300;

function ListItemLink(props) {
    const {data, open, classname, selected, ...other} = props;

    useEffect(() => {
    }, [selected])

    return (
        <li className={selected ? 'selectedSideBar' : ''}>
            <ListItemButton
                selected={selected}
                component={RouterLink}
                to={data.link} {...other}
            >
                <ListItemText className={classname} primary={data.title}/>
                {open != null ? open ? <ExpandLess/> : <ExpandMore/> : null}
            </ListItemButton>
        </li>
    );
}

ListItemLink.propTypes = {
    open: PropTypes.bool,
    selected: PropTypes.bool

};

function ListUnit(props) {
    const [open, setOpen] = useState(false);
    const {data, selected, setSelected} = props;


    return (
        <React.Fragment>
            {data.children ?
                <React.Fragment>
                    <ListItemLink
                        data={data}
                        open={open}
                        classname="unitLiMainSidebarCounter"
                        onClick={() => setOpen(!open)}
                    />
                    <Collapse
                        component="li"
                        in={open}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List disablePadding>
                            {data.children.map((x, i) => (
                                <ListItemLink
                                    data={x}
                                    key={i}
                                    classname="unitLiSubSidebarCounter"
                                    onClick={() => setSelected(x.link)}
                                    selected={x.link === selected}
                                />
                            ))}
                        </List>
                    </Collapse>
                </React.Fragment>
                :
                <ListItemLink
                    data={data}
                    onClick={() => setSelected(data.link)}
                    selected={data.link === selected}
                />
            }
        </React.Fragment>
    )
}

function HeaderAndFooterLayout(props) {
    const {window, children} = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [selected, setSelected] = useState("");
    const location = useLocation();
    const dispatch = useDispatch();
    const {promiseInProgress} = usePromiseTracker();
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    function exitOfApp() {
        const callback = () => dispatch(logOut())
        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }


    if (location.pathname === '/signin' || location.pathname === '/signup' || location.pathname === '/forgot-password') {
        return (
            <div display="flex" width={1} style={{minHeight: '100vh'}}>
                {children}
            </div>
        );
    }

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{display: 'flex', height: '100vh'}}>
            <Notifier/>
            <AppBar
                position="fixed"
                sx={{
                    display: {md: 'none'},
                    width: {md: mobileOpen ? `calc(100% - ${drawerWidth}px)` : '100%'},
                    transition: '225ms',
                    mr: {md: mobileOpen ? `${drawerWidth}px` : 0},
                    backgroundColor: '#66c2c9'
                }}
            >
                <Toolbar
                    direction="row"
                    justify="center"
                    style={{display: 'flex', justifyContent: 'space-between'}}
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                    >
                        {!mobileOpen && <MenuIcon/>}
                    </IconButton>
                    <IconButton
                        color="inherit"
                        onClick={exitOfApp}
                    >
                        <ExitToAppIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{
                    width: {md: mobileOpen ? drawerWidth + 65 : 65},
                    flexShrink: {sm: 0},
                }}
                className="sideBarBox"
                aria-label="mailbox folders"
            >

                <Drawer
                    container={container}
                    variant="temporary"
                    anchor="right"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: {xs: 'block', sm: 'block', md: 'none'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                >

                    <List className='sideBarBox'>
                        {strings.breadcrumbNameMap.map((data, i) => {
                            return <ListUnit key={i} data={data} selected={selected}
                                             setSelected={(e) => setSelected(e)}/>
                        })}
                    </List>
                </Drawer>
                <Box
                    position="fixed"
                    sx={{
                        display: {xs: 'none', sx: 'none', md: 'flex'},
                        flexDirection: 'row',
                        width: 'max-content',
                        overflow: 'hidden',
                        transition: '225ms',
                        height: '100vh',
                    }}
                >
                    <Box
                        sx={{
                            display: {xs: 'none', sx: 'none', md: 'flex'},
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: 65,
                            padding: '10px 0',
                            backgroundColor: '#66c2c9'
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerToggle}
                        >
                            {!mobileOpen ? <MenuIcon/> : <CloseIcon/>}
                        </IconButton>
                        <IconButton
                            color="inherit"
                            onClick={exitOfApp}
                        >
                            <ExitToAppIcon/>
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            width: {md: mobileOpen ? drawerWidth : 0},
                            transition: '225ms',
                            backgroundColor: 'white',
                            overflowY: 'scroll'
                        }}
                    >
                        <Toolbar
                            direction="row"
                            justify="center"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
                            }}
                        >
                            <img
                                src={logo}
                                alt="" className="LogoSidebarAdmin"/>
                        </Toolbar>
                        <List>
                            {strings.breadcrumbNameMap.map((data, i) => {
                                return <ListUnit key={i} data={data} selected={selected}
                                                 setSelected={(e) => setSelected(e)}/>
                            })}
                        </List>
                    </Box>
                </Box>
            </Box>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    pt: {xs: 9, sm: 10, md: 4, lg: 3},
                    px: {xs: 2, sm: 3, md: 4, lg: 5},
                    display: 'flex',
                    justifyContent: 'center',
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: mobileOpen ? `calc(100% - ${(drawerWidth + 65)}px)` : `calc(100% - 65px)`
                    },
                    boxSizing: 'border-box'
                }}
            >
                <CacheProvider value={cacheRtl}>
                    {children}

                    {/*<LoadingComponents/>*/}
                </CacheProvider>
            </Box>
            {/*<Loader promiseTracker={usePromiseTracker} color={`#66c2c9`}/>*/}
            {promiseInProgress &&
            <div className="ParentLoading w-100 d-flex justify-content-center align-items-center">
                {/*<LoadingComponents/>*/}
                <Loader promiseTracker={usePromiseTracker} color={`#66c2c9`}/>
            </div>
            }
        </Box>
    );
}


export default HeaderAndFooterLayout;

// function HeaderAndFooterLayout({children}) {
//     const Location = useLocation();
//     const drawerCart = useSelector(selDrawerCart)
//     const loading = useSelector(selLoading)
//     const [openDrawer, setOpenDrawer] = useState(true);
//     const [mobileOpen, setMobileOpen] = useState(false);
//     const [selected, setSelected] = useState("");
//     const location = useLocation();
//
//     function ListItemLink(props) {
//         const {data, open, classname, ...other} = props;
//         return (
//             <li>
//                 <ListItem
//                     button
//                     component={RouterLink}
//                     to={data.link} {...other}
//                     selected={data.link === selected}
//                 >
//                     <ListItemText className={classname} primary={data.title}/>
//                     {open != null ? open ? <ExpandLess/> : <ExpandMore/> : null}
//                 </ListItem>
//             </li>
//         );
//     }
//
//     ListItemLink.propTypes = {
//         open: PropTypes.bool,
//     };
//
//     function ListUnit(props) {
//         const [open, setOpen] = useState(false);
//         const {data} = props;
//
//         return (
//             data.children ?
//                 <React.Fragment>
//                     <ListItemLink
//                         data={data}
//                         open={open}
//                         classname="unitLiMainSidebarCounter"
//                         onClick={() => setOpen(!open)}
//                     />
//                     <Collapse
//                         component="li"
//                         in={open}
//                         timeout="auto"
//                         unmountOnExit
//                     >
//                         <List disablePadding>
//                             {data.children.map((x, i) => (
//                                 <ListItemLink
//                                     data={x}
//                                     key={i}
//                                     classname="unitLiSubSidebarCounter"
//                                 />
//                             ))}
//                         </List>
//                     </Collapse>
//                 </React.Fragment>
//                 :
//                 <ListItemLink
//                     data={data}
//                     onClick={() => setSelected(data.link)}
//                 />
//         )
//     }
//
//     if (location.pathname === '/signin' || location.pathname === '/signup' || location.pathname === '/forgot-password') {
//         return (
//             <div display="flex" width={1} style={{ minHeight: '100vh' }}>
//                 {children}
//             </div>
//         );
//     }
//
//
//
//     const handleDrawerToggle = () => {
//         setMobileOpen(!mobileOpen);
//     };
//
//     const pathnames = location.pathname.split('/').filter((x) => x);
//     let first = pathnames.length === 2 && pathnames[0];
//
//     const container = window !== undefined ? () => window.document.body : undefined;
//
//     return (
//         // <div
//         //     className={`App d-flex flex-column Counter align-items-center`}
//         // >
//         // </div>
//     <Box sx={{ display: 'flex', direction: 'rtl'}} >
//         <CssBaseline />
//         <Notifier/>
//         <AppBar
//             position="fixed"
//             sx={{
//                 width: { sm: `calc(100% - ${drawerWidth}px)` },
//                 ml: { sm: `${drawerWidth}px` },
//             }}
//         >
//             <Toolbar>
//                 <IconButton
//                     color="inherit"
//                     aria-label="open drawer"
//                     edge="start"
//                     onClick={handleDrawerToggle}
//                     sx={{ mr: 2, display: { sm: 'none' } }}
//                 >
//                     <MenuIcon />
//                 </IconButton>
//                 <Typography variant="h6" noWrap component="div">
//                     Responsive drawer
//                 </Typography>
//             </Toolbar>
//             {/*<div className="Header">*/}
//             {/*    <HeaderCounter/>*/}
//             {/*    <div className="w-100">*/}
//             {/*        <div className="HeaderDown d-flex justify-content-between align-items-center">*/}
//             {/*            <Breadcrumbs separator={<i className="fas fa-angle-double-left DoubleLeft"/>}*/}
//             {/*                         aria-label="breadcrumb">*/}
//             {/*                <Link color="inherit" to="/">*/}
//             {/*                    <img className="houseIcon" src={house} alt=""/>*/}
//             {/*                </Link>*/}
//             {/*                {pathnames.map((value, index) => {*/}
//             {/*                    const last = index === pathnames.length - 1;*/}
//             {/*                    const to = `/${pathnames.slice(0, index + 1).join('/')}`;*/}
//             {/*                    const data = last && first ? strings.breadcrumbNameMap.filter(x => x.link === `/${first}`)[0] : strings.breadcrumbNameMap.filter(x => x.link === to)[0];*/}
//             {/*                    const dataTwo = last && first && data.children.filter(x => x.link === to)[0]*/}
//             {/*                    return last ? (*/}
//             {/*                        dataTwo !== undefined &&*/}
//             {/*                        <Typography color="textPrimary"*/}
//             {/*                                    key={first ? dataTwo.title : data?.title}>*/}
//             {/*                            {first ? dataTwo?.title : data?.title}*/}
//             {/*                        </Typography>*/}
//             {/*                    ) : (*/}
//             {/*                        <Link color="inherit" to={data.link} key={data.link}>*/}
//             {/*                            {data.title}*/}
//             {/*                        </Link>*/}
//             {/*                    );*/}
//             {/*                })}*/}
//             {/*            </Breadcrumbs>*/}
//             {/*            <h3 className="date">{moment(new Date()).locale("fa")*/}
//             {/*                .format("dddd D MMMM YYYY")}</h3>*/}
//             {/*        </div>*/}
//             {/*    </div>*/}
//             {/*</div>*/}
//         </AppBar>
//         <Box
//             component="nav"
//             sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//             aria-label="mailbox folders"
//         >
//             {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
//             <Drawer
//                 container={container}
//                 variant="temporary"
//                 open={mobileOpen}
//                 onClose={handleDrawerToggle}
//                 ModalProps={{
//                     keepMounted: true, // Better open performance on mobile.
//                 }}
//                 sx={{
//                     display: { xs: 'block', sm: 'none' },
//                     '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, right: 0, left: 'auto' },
//                 }}
//             >
//                     <button
//                         className={openDrawer ? `closeHandle handleSideBar` : `openHandle handleSideBar`}
//                         onClick={() => setOpenDrawer(!openDrawer)}
//                     >
//                         <i className="fas fa-list-alt"/></button>
//                     <div
//                         className={`parentAllSidebarCounter overflow-hidden ${
//                             openDrawer ? `parentAlSidebarCounterOpen` : `parentAlSidebarCounterClose`
//                         }`}
//                     >
//                         <List>
//                             {strings.breadcrumbNameMap.map((data, i) => {
//                                 return <ListUnit key={i} data={data}/>
//                             })}
//                         </List>
//                     </div>
//             </Drawer>
//             <Drawer
//                 variant="permanent"
//                 sx={{
//                     display: { xs: 'none', sm: 'block' },
//                     '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, right: 0, left: 'auto' },
//                 }}
//                 open
//             >
//                 <div>
//                     <button
//                         className={openDrawer ? `closeHandle handleSideBar` : `openHandle handleSideBar`}
//                         onClick={() => setOpenDrawer(!openDrawer)}
//                     >
//                         <i className="fas fa-list-alt"/></button>
//                     <div
//                         className={`parentAllSidebarCounter overflow-hidden ${
//                             openDrawer ? `parentAlSidebarCounterOpen` : `parentAlSidebarCounterClose`
//                         }`}
//                     >
//                         <List>
//                             {strings.breadcrumbNameMap.map((data, i) => {
//                                 return <ListUnit key={i} data={data}/>
//                             })}
//                         </List>
//                     </div>
//                 </div>
//             </Drawer>
//         </Box>
//         <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
//             <Toolbar />
//             {children}
//         </Box>
//     </Box>
//     );
// }
//
// export default HeaderAndFooterLayout

// export default function IntegrationNotistack() {
//     return (
//         <SnackbarProvider maxSnack={10} anchorOrigin={{vertical: "top", horizontal: "center"}}>
//             <HeaderAndFooterLayout/>
//         </SnackbarProvider>
//     );
// }